import React, { useState } from 'react';
import PropTypes from 'prop-types';

const UsersList = ({
  users = [],
  courseId,
  selectedUsers,
  setSelectedUsers,
}) => {
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectUser = (user) => {
    setSelectedUsers((prevSelectedUsers) => {
      const isAlreadySelected = prevSelectedUsers.some(
        (selectedUser) => selectedUser?._id === user?._id
      );

      if (isAlreadySelected) {
        return prevSelectedUsers.filter(
          (selectedUser) => selectedUser?._id !== user?._id
        );
      } else {
        return [...prevSelectedUsers, user];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(users);
    }
    setSelectAll(!selectAll);
  };

  return (
    <table>
      <thead>
        <tr>
          <th>
            Select
            <input
              style={{ marginLeft: '1rem' }}
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
            />
          </th>
          <th>User Name</th>
          <th>Course Status</th>
        </tr>
      </thead>
      <tbody>
        {users?.map((user) => {
          const userCourse = user?.courses?.find(
            (course) => course.courseId === courseId
          );
          let courseStatus = '';
          let statusStyle = { color: '' };

          if (courseId) {
            if (!userCourse) {
              courseStatus = 'User does not have the course';
              statusStyle = { color: 'green' };
            } else if (!userCourse.completed) {
              courseStatus = 'Course not completed';
              statusStyle = { color: 'orange' };
            } else if (new Date(userCourse.expiryDate) < new Date()) {
              courseStatus = `Course expired on ${new Date(userCourse.expiryDate).toLocaleDateString()}`;
              statusStyle = { color: 'red' };
            } else {
              courseStatus = `Course completed, expires on ${new Date(userCourse.expiryDate).toLocaleDateString()}`;
              statusStyle = { color: 'red' };
            }
          }

          const isSelected = selectedUsers.some(
            (selectedUser) => selectedUser?._id === user?._id
          );

          return (
            <tr key={user?._id}>
              <td>
                <input
                  type="checkbox"
                  name="selectedUser"
                  value={user?._id}
                  checked={isSelected}
                  onChange={() => handleSelectUser(user)}
                />
              </td>
              <td>
                {user?.firstName} {user?.lastName}
              </td>
              <td style={statusStyle}>{courseStatus}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

UsersList.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      courses: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          completed: PropTypes.bool,
          expiryDate: PropTypes.string,
        })
      ),
    })
  ),
  courseId: PropTypes.string,
  selectedUsers: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      courses: PropTypes.array,
    })
  ),
  setSelectedUsers: PropTypes.func,
};

export default UsersList;
